import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import OrderList from '../components/orders/OrderList';
import OrderForm from '../components/orders/OrderForm';
import OrderDetail from '../components/orders/OrderDetail';
import useAuth from '../hooks/useAuth';
import { useLocation } from 'react-router-dom';

const OrderManagement = () => {
    const [view, setView] = useState('list');
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [editMode, setEditMode] = useState(false);

    const handleCreateOrder = () => {
        setSelectedOrderId(null);
        setView('form');
    };

    const handleViewOrder = (orderId, edit = false) => {
        setSelectedOrderId(orderId);
        setEditMode(edit);
        // L'édition ouvre le formulaire pré-rempli ; la consultation ouvre le détail.
        setView(edit ? 'form' : 'detail');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedOrderId(null);
        setEditMode(false);
    };

    const location = useLocation();
    useEffect(() => {
        handleCancel(); // remet view='list' + selectedProductId=null
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    const handleSuccess = () => {
        setView('list');
        setSelectedOrderId(null);
        setEditMode(false);
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion commandes</h1>
            </div>

            {view === 'list' && (
                <OrderList
                    onViewOrder={handleViewOrder}
                    onCreateOrder={handleCreateOrder}
                />
            )}

            {view === 'form' && (
                <OrderForm
                    orderId={selectedOrderId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'detail' && (
                <OrderDetail
                    orderId={selectedOrderId}
                    editMode={editMode}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}
        </Container>
    );
};

export default OrderManagement;